import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button } from "antd";
import PropTypes from "prop-types";
import "../payment/guestPaymentForm.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import TermsAndConditions from "../common/TermsAndConditions";
import CCButton from "../common/CCButtonV3";
import eye_regular from "../../images/eye-regular.svg";
import eye_slash_solid from "../../images/eye-slash-solid.svg";
import * as link from '../common/pages'
import "./style.css";
import ResetPassword from "./reset-password";
import { connect } from "react-redux";
import SocialLoginView from "./SocialLoginView";
import * as ccAnalytics from "../../util/analytics/ccAnalytics";
import OrView from './OrView';
import { signIn } from "./authentication";
import {useRouteMatch} from "react-router-dom";
import UIContext from "../../util/UIContext";
import { validateEmail } from "./emailValidation";

const SignIn = ({ trackPageViews, user, defaultEmail, onSwitchToSignUp, googleAnalyticsParentPath }) => {

  const match = useRouteMatch();
  const uiContext = useContext(UIContext);
  const { hideSocialMedia } = uiContext?.content?.signIn?.individual || {};

  const [emailAddr, setEmailAddr] = useState(defaultEmail || "");
  const [password, setPassword] = useState("");
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [errorPassword, setPasswordError] = useState({
    message: "NA",
    error: false
  });
  const [loading, setLoading] = useState(false);
  const [errorEmail, setEmailError] = useState(false);
  const emailDomains = uiContext?.emailDomains;

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmailAddr(value);
    setEmailError(!validateEmail(value, emailDomains));
  };

  useEffect(() => {
    if(trackPageViews){
      ccAnalytics.pageview(`${googleAnalyticsParentPath}/sign-in`);
    }
  }, []);

  const goToHome = () => {
    window.location = match.url+link.DASHBOARD;
  }

  const handlePasswordChange = (e) => {
    const { value } = e.target;
    setPassword(value);
  };

  const handleSignIn = async (e) => {
    e.preventDefault();
    setLoading(true);
    await appSignIn(emailAddr, password);

  };

  async function appSignIn(username, password) {
    if (username.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
      await signIn(username, password)
        .then(() => goToHome())
        .catch((err) => {
          setPasswordError({
            message: "Incorrect password",
            error: true
          });
          console.error("Auth Error: %o" , err);
        });
    }
    setLoading(false);
  }

  const hasFacebookLogin = (user && user.loginMethods && (user.loginMethods.find(method => method.loginMethodCode==='COGNITO_FACEBOOK'))) ? true : false;
  const hasGoogleLogin = (user && user.loginMethods && (user.loginMethods.find(method => method.loginMethodCode==='COGNITO_GOOGLE'))) ? true : false;
  const hasPasswordLogin = (user && user.loginMethods && (user.loginMethods.find(method => method.loginMethodCode==='COGNITO_PASSWORD'))) ? true : false;

  const SignInButton = (
    <CCButton
      buttonName="Sign me in"
      onClickButton={handleSignIn}
      isDisabled={errorEmail || password.length < 8}
      size="large"
      type="primary"
      loading={loading}
    />
  );

  const EmailValidation = errorEmail ? (
    <Row>
      <span style={{ color: "red", fontSize: 14 }}>Email is not valid</span>
    </Row>
  ) : null;

  return (
    <div className="signFormWrapper">
      <form onSubmit={handleSignIn}>

        {!hideSocialMedia && (
          <>
        <Row className="div-spacing w-100">
            <SocialLoginView />
        </Row>
          <Row className="w-100" gutter={8} style={{ paddingTop: 20 }}>
            <OrView />
          </Row>
          </>
        )}

        <Row>
          <div className="inputWrapper text-left w-100">
            <input
              value={emailAddr}
              type="email"
              size="large"
              name="email"
              onChange={handleEmailChange}
              placeholder="Enter email address"
              style={{ ...INPUT_STYLE }}
            />
          </div>
        </Row>
        {EmailValidation}

        <Row className="div-spacing w-100">
          <div className="inputWrapper w-100">
            <Row className="w-100">
              <Col span={22}>
                <input
                  type={!isPasswordVisible ? "password" : "text"}
                  value={password}
                  size="large"
                  onChange={handlePasswordChange}
                  placeholder="Enter password"
                  style={{
                    ...INPUT_STYLE
                  }}
                />
              </Col>
              <Col span={2}>
                <img
                  onClick={() => setPasswordVisible(!isPasswordVisible)}
                  style={{ width: 20 }}
                  src={isPasswordVisible ? eye_slash_solid : eye_regular}
                />
              </Col>
            </Row>
          </div>
        </Row>
        
        <Row className="w-100">
          <span style={{ fontSize: 12, color: "red" }}>
            {errorPassword.error ? errorPassword.message : null}
          </span>
        </Row>
        <Row className="div-spacing w-100">
        <a className="forgot-password-link" onClick={() => setModalVisible(true)}>
          Forgot Password?
        </a>
        </Row>

        <Row className="div-spacing w-100">
          <TermsAndConditions />
        </Row>
        <Row className="div-spacing w-100">
          <Col span={13} style={{ ...MOBILE_STYLE }}>
          </Col>
          <Col span={11} style={{ ...MOBILE_STYLE, textAlign: "right" }}>
            {SignInButton}
          </Col>
        </Row>

        <Row className="div-spacing w-100" style={{ justifyContent: "center", alignItems: 'center', gap: 8 }}>
          <p style={{ fontSize: 14, marginBottom: 0 }}>Don’t have an account?</p>
          <a style={{ fontSize: 14 }} onClick={onSwitchToSignUp}>
            Get started
          </a>
        </Row>
      </form>
      {modalVisible && <ResetPassword showModal={true} 
                        setModalVisible={setModalVisible} 
                        email={emailAddr}/>}
    </div>
  );
};

const INPUT_STYLE = {
  height: "auto",
  padding: 0,
  fontSize: "20px",
  lineHeight: "1.3em",
  width: "100%",
  color: "black",
  "::placeholder": {
    color: "#aab7c4"
  },
  border: 0,
  outline: 0
};

const MOBILE_STYLE = { paddingTop: 10 };

SignIn.propTypes = {
  defaultEmail: PropTypes.string,
  onSwitchToSignUp: PropTypes.func,
  isMobileDevice: PropTypes.bool,
  showGoBackButton: PropTypes.bool,
  trackPageViews: PropTypes.bool,
  googleAnalyticsParentPath: PropTypes.string
};

function mapStateToProps(state) {
  return {
    user: state.user
  };
}

export default connect(mapStateToProps)(SignIn);